export const validarEmail = (email) => {
  const regex = /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i
  return regex.test(email)
}

export const numbersOnly = (value) =>
  String(value)?.replaceAll(/\D/gm, '') || ''
